export interface RuntimeConfig {
  environment: string;
  public_url: string;
  subdomain_host?: string;
  oidc: { enabled: boolean; login_url: string };
  funnelbarn: { endpoint: string; api_key: string; project: string };
  iambarn: { issuer: string; profile_url: string };
  theme: { primary: string; bg: string; card: string; text: string };
}

export interface Me {
  sub: string;
  email: string;
  display_name: string;
  organization_id: string;
  groups: string[];
}

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method,
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
    credentials: "same-origin",
  });
  const text = await res.text();
  if (!res.ok) {
    let message = res.statusText;
    try {
      const parsed = JSON.parse(text) as { error?: string };
      if (parsed.error) message = parsed.error;
    } catch {
      /* ignore */
    }
    throw new ApiError(res.status, message);
  }
  if (!text) return undefined as unknown as T;
  return JSON.parse(text) as T;
}

export const authApi = {
  runtimeConfig: () => request<RuntimeConfig>("GET", "/api/v1/runtime-config"),
  me: () => request<Me>("GET", "/api/v1/auth/me"),
  logout: () => request<void>("POST", "/api/v1/auth/logout"),
  oidcLoginUrl: () => request<{ url: string }>("GET", "/api/v1/auth/oidc/login-url"),
};
